export default __webpack_public_path__ + "static/media/gallery_04.3e6fbea7.jpg";